import { events, data } from './state';
import Cookies from './cookies';
import User from './user';
import Customer, { useCustomerDetails } from './customer';
import Delegate from './delegate';
import Employee from './employee';
import traffic2, { useTraffic } from './traffic2';
import * as url from './url';
import shopperDataLoader from './shopper-data';
import { usePageConfig, useOrderDetails } from './context';
import { useHivemind } from './hivemind';

//
// Add useful methods.
//
export {
  Cookies,
  events,
  data,
  User,
  Customer,
  Delegate,
  Employee,
  traffic2,
  url,
  shopperDataLoader,
  useCustomerDetails,
  useHivemind,
  usePageConfig,
  useOrderDetails,
  useTraffic
};
